import { useSelector, useDispatch } from "react-redux";
import { modalActions } from "../../store/ModalSlice";
import "./ErrorModal.css";
import SubmitIcon from "../../assets/icons/inventory.svg";
import { peopleActions } from "../../store/PeopleSlice";
import { loadingActions } from "../../store/LoaderSlice";
import { managerActions } from "../../store/ManagerSlice";
import { requestActions } from "../../store/RequestSlice";
import { authActions } from "../../store/AuthSlice";
import { SSOAuthorization } from "more-sso-sdk";

const ErrorModal = () => {
    const dispatch = useDispatch();
    const errorMessage = useSelector(state => state.modal.errorMessage);
    const errorModalState = useSelector(state => state.modal.errorModalState);
    const errorModalStatus = useSelector(state => state.modal.errorStatus);
    const errorDetails = useSelector(state => state.modal.errorDetails)
    const url = useSelector(state => state.modal.url)



    if (!errorModalState) return null;

    const errorJson = errorDetails?.flatMap(detail =>
        Object.entries(detail.errors).map(([field, value]) => ({
            row: detail.row,
            field,
            value
        }))
    );

    return (
        <div className="error-modal-overlay">
            <div className="error-modal">
                <div className="error-modal-header">
                    <h5 className="error-modal-title">{errorModalStatus == "success" ? "Success" : "⚠ Error"}</h5>
                </div>
                <div className="error-modal-body" style={{ maxHeight: "300px", overflowY: "auto" }}>

                    {errorDetails?.length > 0 ? (
                        <>
                            <p>{errorMessage || "Invalid data found"}</p>
                            <table className="w-full border border-gray-300 text-sm mt-3">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th>Row</th>
                                        <th>Field</th>
                                        <th>Invalid Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {errorJson.map((err, index) => (
                                        <tr key={index}>
                                            <td>{err.row}</td>
                                            <td>{err.field}</td>
                                            <td>{err.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    ) : (
                        <p>{errorMessage}</p>
                    )}
                </div>
                <div className="error-modal-footer">
                    <button
                        className="btn p-btn p-btn-og"
                        onClick={() => {
                            dispatch(modalActions.setErrorModal({ state: false, message: "", status: "" }))
                            //logout
                            if (errorMessage === "Session Expired. Please re-login.") {
                                dispatch(authActions.setInitialState());
                                dispatch(peopleActions.setInitialState());
                                dispatch(modalActions.setInitialState());
                                dispatch(loadingActions.setInitialState());
                                dispatch(managerActions.setInitialState());
                                dispatch(requestActions.setInitialState());
                                dispatch(authActions.logout());
                                if (process.env.REACT_APP_ENV === 'UAT')
                                    SSOAuthorization.logout("https://people-uat.more.in/")
                                else
                                    SSOAuthorization.logout("https://people.more.in/")
                            }
                        }}
                    >
                        {/* <img className="p-btn-icon" alt="" src={SubmitIcon} /> */}
                        <div className="p-btn-text">  OK  </div>
                    </button>
                    {url && <button
                        className="btn p-btn p-btn-og"
                        onClick={() => {
                            window.open(url, "_blank");
                            dispatch(modalActions.setErrorModal({ state: false, message: "", status: "" }))
                        }}
                    >
                        <div className="p-btn-text">  Download  </div>
                    </button>
                    }
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;
